import { TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_MailHeaderCreated extends _Event {
    constructor(payload: EventSchema<Template_MailHeaderCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            mailContent: z.string().min(1),
            mailHTMLContent: z.string().min(1),
            type: z.literal(TEMPLATE_TYPES.MAIL_HEADER),
        });
    }

    static example(): EventSchema<Template_MailHeaderCreated> {
        return {
            mailContent: 'This is the mail content',
            mailHTMLContent: '<html><body>This is the mail HTML content</body></html>',
            type: TEMPLATE_TYPES.MAIL_HEADER,
        };
    }
}
